"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeLanguage = exports.getErrorByField = exports.getSearchText = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var react_select_1 = require("react-select");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var languages_1 = require("utils/helpers/languages");
var Icon_1 = require("components/Icon");
var AddNewCustomerModal_1 = require("../modals/AddNewCustomerModal");
require("./step1.scss");
/**
 * For customer search
 * @param isFetching
 * @return message
 */
var getSearchText = function (isFetching) {
    return isFetching
        ? (0, translation_1.getLocalization)('firstTimeLogin/step1/customer/searching')
        : (0, translation_1.getLocalization)('firstTimeLogin/step1/customer/noResults');
};
exports.getSearchText = getSearchText;
var getErrorByField = function (field, error) {
    if (error && error.length > 0) {
        return React.createElement("div", { className: 'error' }, error[0]);
    }
    return undefined;
};
exports.getErrorByField = getErrorByField;
var changeLanguage = function (language, props) {
    props.setLanguage(language);
    props.fetchLanguage(language);
    return language;
};
exports.changeLanguage = changeLanguage;
var Input = (0, recompose_1.compose)((0, recompose_1.withState)('value', 'setValue', null), recompose_1.pure)(function (props) {
    var value = '';
    if (props.user) {
        if (props.value === null) {
            value = props.user[props.fieldName];
        }
        else {
            value = props.value;
        }
    }
    return (React.createElement(sok_ui_1.TextInput, { id: props.id, key: "input-".concat(props.fieldName), className: 'white', value: value, onChange: function (e) { return props.setValue(e.target.value); }, onBlur: function () {
            var oldValue = props.user[props.fieldName] || '';
            if (value === oldValue) {
                return;
            }
            props.updateField(props.fieldName)(value);
            props.setValue(null);
        }, disabled: props.disabled }));
});
var component = function (props) {
    var user = props.firstLogin.step1.user;
    var errors = props.firstLogin.step1.status === 'ERROR'
        ? props.firstLogin.step1.errors
        : {};
    var someUser = props.auth.current.user;
    if (someUser.isSome()) {
        user.email = someUser.value.email;
    }
    var status = props.firstLogin.step1.status;
    return (React.createElement("div", { key: 'step1', className: 'first-login-view-step1' },
        React.createElement(sok_ui_1.Tabs, { className: 'first-login-view-tabsbar', activeIndex: 0, onClick: function () {
                /* for lint */
            } },
            React.createElement("div", { key: 'tab' }, (0, translation_1.getLocalization)('firstTimeLogin/step1/profileInformation')),
            React.createElement("div", { key: 'tab-content', className: 'tab-content' },
                React.createElement("div", { className: 'user-information' },
                    React.createElement(sok_ui_1.Grid.Row, null,
                        React.createElement(sok_ui_1.Grid.Column, { medium: 12 },
                            React.createElement("label", { htmlFor: "company-name" },
                                React.createElement(Icon_1.Icon, { className: 'icofont-company' }),
                                ' ',
                                (0, translation_1.getLocalization)('firstTimeLogin/step1/company')),
                            props.auth.current.user
                                .map(function (_a) {
                                var company = _a.company;
                                return !company || (company && company.length === 0);
                            })
                                .getOrElse(true) ? (React.createElement("div", { className: 'search-company-row' },
                                React.createElement(react_select_1.default, { menuPlacement: 'auto', classNamePrefix: "react-select", placeholder: (0, translation_1.getLocalization)('firstTimeLogin/step1/searchCompany'), value: props.firstLogin.customer.companies.find(function (a) { return a.id === props.firstLogin.customerId; }), options: props.firstLogin.customer.companies, getOptionValue: function (opt) { return opt.id; }, getOptionLabel: function (opt) { return opt.name; }, isLoading: props.firstLogin.customer.isFetching, onInputChange: function (input) {
                                        props.setCustomerSearchString(input);
                                    }, onChange: props.setExistCustomer, noOptionsMessage: function () {
                                        return (0, exports.getSearchText)(props.firstLogin.customer.isFetching);
                                    } }),
                                React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('firstTimeLogin/step1/addNewCompany'), color: 'base-green', onClick: props.toggleModal }))) : (React.createElement(sok_ui_1.TextInput, { id: 'company-name', className: 'white', value: props.auth.current.user
                                    .map(function (x) { return x.company || ''; })
                                    .getOrElse(''), disabled: true })),
                            status === 'ERROR'
                                ? (0, exports.getErrorByField)('company', errors['company'])
                                : null)),
                    React.createElement(sok_ui_1.Grid.Row, null,
                        React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                            React.createElement("label", { htmlFor: "first-name" },
                                React.createElement(Icon_1.Icon, { className: 'fa-user' }),
                                ' ',
                                (0, translation_1.getLocalization)('firstTimeLogin/step1/firstName')),
                            React.createElement(Input, { id: 'first-name', fieldName: 'firstName', user: user, updateField: props.updateField }),
                            status === 'ERROR'
                                ? (0, exports.getErrorByField)('firstName', errors['firstName'])
                                : null),
                        React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                            React.createElement("label", { htmlFor: "last-name" },
                                React.createElement(Icon_1.Icon, { className: 'fa-user' }),
                                ' ',
                                (0, translation_1.getLocalization)('firstTimeLogin/step1/lastName')),
                            React.createElement(Input, { id: 'last-name', fieldName: 'lastName', user: user, updateField: props.updateField }),
                            status === 'ERROR'
                                ? (0, exports.getErrorByField)('lastName', errors['lastName'])
                                : null)),
                    React.createElement(sok_ui_1.Grid.Row, null,
                        React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                            React.createElement("label", { htmlFor: "title" },
                                React.createElement(Icon_1.Icon, { className: 'fa-briefcase' }),
                                ' ',
                                (0, translation_1.getLocalization)('firstTimeLogin/step1/title')),
                            React.createElement(Input, { id: 'title', fieldName: 'title', user: user, updateField: props.updateField }),
                            status === 'ERROR'
                                ? (0, exports.getErrorByField)('title', errors['title'])
                                : null),
                        React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                            React.createElement("label", { htmlFor: "telephone" },
                                React.createElement(Icon_1.Icon, { className: 'fa-phone' }),
                                ' ',
                                (0, translation_1.getLocalization)('firstTimeLogin/step1/phone')),
                            React.createElement(Input, { id: 'telephone', fieldName: 'telephone', user: user, updateField: props.updateField }),
                            status === 'ERROR'
                                ? (0, exports.getErrorByField)('telephone', errors['telephone'])
                                : null)),
                    React.createElement(sok_ui_1.Grid.Row, null,
                        React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                            React.createElement("label", { htmlFor: "email" },
                                React.createElement(Icon_1.Icon, { className: 'fa-envelope' }),
                                ' ',
                                (0, translation_1.getLocalization)('firstTimeLogin/step1/email')),
                            React.createElement(sok_ui_1.TextInput, { id: 'email', className: 'white', value: user.email, disabled: true }),
                            status === 'ERROR'
                                ? (0, exports.getErrorByField)('email', errors['email'])
                                : null),
                        React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                            React.createElement("label", { htmlFor: "language" },
                                React.createElement(Icon_1.Icon, { className: 'fa-language' }),
                                ' ',
                                (0, translation_1.getLocalization)('firstTimeLogin/step1/language')),
                            React.createElement(react_select_1.default, { inputId: "language", menuPlacement: 'auto', classNamePrefix: "react-select", placeholder: (0, translation_1.getLocalization)('firstTimeLogin/step1/language/placeHolder'), options: languages_1.languageData.map(function (_a) {
                                    var code = _a.code, name = _a.name;
                                    return ({
                                        code: code,
                                        name: name
                                    });
                                }), getOptionValue: function (opt) { return opt.code; }, getOptionLabel: function (opt) { return opt.name; }, value: props.language, onChange: function (_a) {
                                    var code = _a.code;
                                    return (0, exports.changeLanguage)(code, props);
                                }, isSearchable: true, isClearable: false }))),
                    React.createElement(sok_ui_1.Grid.Row, null,
                        React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                            React.createElement("label", { htmlFor: 'street' },
                                React.createElement(Icon_1.Icon, { className: 'fa-map-marker' }),
                                ' ',
                                (0, translation_1.getLocalization)('firstTimeLogin/step1/address')),
                            React.createElement(Input, { id: 'street', fieldName: 'street', user: user, updateField: props.updateField }),
                            status === 'ERROR'
                                ? (0, exports.getErrorByField)('street', errors['street'])
                                : null),
                        React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                            React.createElement("label", { htmlFor: "country" },
                                React.createElement(Icon_1.Icon, { className: 'fa-map-marker' }),
                                ' ',
                                (0, translation_1.getLocalization)('firstTimeLogin/step1/country')),
                            React.createElement(react_select_1.default, { inputId: "country", menuPlacement: 'auto', classNamePrefix: "react-select", placeholder: (0, translation_1.getLocalization)('firstTimeLogin/step1/country/placeHolder'), value: props.firstLogin.regions.list.find(function (v) { return v.code === user.country; }), options: props.firstLogin.regions.list, onChange: props.setCountry, getOptionValue: function (opt) { return opt.code; }, getOptionLabel: function (opt) { return opt.name; }, isSearchable: true, isClearable: false }),
                            status === 'ERROR'
                                ? (0, exports.getErrorByField)('country', errors['country'])
                                : null)),
                    React.createElement(sok_ui_1.Grid.Row, null,
                        React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                            React.createElement("label", { htmlFor: "postalCode" },
                                React.createElement(Icon_1.Icon, { className: 'fa-map-marker' }),
                                ' ',
                                (0, translation_1.getLocalization)('firstTimeLogin/step1/postalCode')),
                            React.createElement(Input, { id: 'postalCode', fieldName: 'postalCode', user: user, updateField: props.updateField }),
                            status === 'ERROR'
                                ? (0, exports.getErrorByField)('postalCode', errors['postalCode'])
                                : null),
                        React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                            React.createElement("label", { htmlFor: "city" },
                                React.createElement(Icon_1.Icon, { className: 'fa-map-marker' }),
                                ' ',
                                (0, translation_1.getLocalization)('firstTimeLogin/step1/postalOffice')),
                            React.createElement(Input, { id: 'city', fieldName: 'city', user: user, updateField: props.updateField }),
                            status === 'ERROR'
                                ? (0, exports.getErrorByField)('city', errors['city'])
                                : null))))),
        React.createElement(AddNewCustomerModal_1.AddNewCustomerModal, null)));
};
exports.default = component;
